import React, { ReactElement } from 'react';

import { Table as AntTable, TableColumnType } from 'antd';
import { ColumnType } from 'antd/lib/table/interface';

export interface IColumnProps<RecordType> extends ColumnType<RecordType> {}
export function TableColumn<T extends TableColumnType<T>>(
  props: IColumnProps<T>
): ReactElement {
  return <AntTable.Column<T> {...props} />;
}
